import _slicedToArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";
// ignore-string-externalization
import { accessTokenManager } from '@mrkt/features/auth';
import { getHash, getVersion } from '../env';
export var defaultWebgateHeaders = {
  accept: 'application/json',
  'content-type': 'application/json',
  'spotify-app-version': "".concat(getVersion(), ".").concat(getHash()).trim(),
  'app-platform': 'Browser'
};
export var WEBGATE_DOMAIN = "https://generic.wg.spotify.com";
export { accessTokenManager };
export function webgateFetch(_x, _x2) {
  return _webgateFetch.apply(this, arguments);
}

function _webgateFetch() {
  _webgateFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, init) {
    var req, token, _i, _Object$entries, _Object$entries$_i, key, value;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = new Request(input, init);
            _context.next = 3;
            return accessTokenManager.get();

          case 3:
            token = _context.sent;

            for (_i = 0, _Object$entries = Object.entries(defaultWebgateHeaders); _i < _Object$entries.length; _i++) {
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
              if (!req.headers.has(key)) req.headers.set(key, value);
            }

            if (token) {
              req.headers.set('authorization', "Bearer ".concat(token));
            } else {
              req.headers.delete('authorization');
            }

            return _context.abrupt("return", fetch(req));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _webgateFetch.apply(this, arguments);
}